import { render, staticRenderFns } from "./ListOfLinks.vue?vue&type=template&id=6fd11f86"
import script from "./ListOfLinks.vue?vue&type=script&lang=js"
export * from "./ListOfLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports